module.exports = "/_next/static/images/AiDrivenCustomer@2x-7580e4ea8f07f98c9ab3dfe600db3cdb.png";